<template>
  <div class="editJobManagement">
    <div class="filters">
      <el-form :inline="true">
        <!-- 权限说明的折叠板 -->
        <el-collapse v-model="collapse" prop="collapse" class="collapse"> 
          <el-collapse-item :title="$t('lang.lab_privilegeDescription')">
            <div><span class="quote">{{$t('lang.lab_code')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionEncoding')}}</div>
            <div><span class="quote">{{$t('lang.lab_codeName')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionDisplayName')}}</div>
            <div><span class="quote">{{$t('lang.lab_cellRights')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_permissUsedCommunityLocated')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_onlyAuthorizedUsePermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_onlyDevelopersPermission')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_permissionOrdinaryAdministrators')}}{{$t('lang.lab_period')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_contain')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span></div>
            <div><span class="quote">{{$t('lang.lab_category')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionsAre')}}<span class="classical">{{$t('lang.lab_radioSelectionType')}}</span>{{$t('lang.lab_suchAsGender')}}{{$t('lang.lab_asWelllAs')}}
                 <span class="classical">{{$t('lang.lab_multipleSelectionType')}}</span>{{$t('lang.lab_suchAsIndividualPermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_status')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_whetherAvailable')}}</div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
      <el-card>
        <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_returnJobManagementList')}}</el-button>
        </div>
          <el-form-item :label="$t('lang.lab_jobManagementName')" prop="Name">
            <el-input v-model="ruleForm.Name" maxlength="50" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_jobManagementName')" class="input-width"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_jobManagementFlag')" prop="Flag">
            <el-select v-model="ruleForm.Flag" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_jobManagementFlag')">
              <el-option
                v-for="(item, index) in flagList"
                :key="index"
                :value="item.id"
                :label="item.name"></el-option>
            </el-select>
          </el-form-item>
      </el-card>
      <el-card class="authority">
        <el-collapse v-model="authorityActiveNames">
          <el-collapse-item
            :label="item.name"
            :prop="item.name"
            class="check-group"
            v-for="(item, index) in authorityList"
            :key="index"
            :title="item.name"
            :name="index"
          >
            <div  v-if="item.authorityType === 1">
              <el-checkbox
                v-model="subitem.checkFlag"
                v-for="(subitem, i) in item.children"
                :key="i"
              >{{subitem.name}}</el-checkbox>
            </div>
            <div v-if="item.authorityType === 0">
              <el-radio-group v-model="radioArray[index]"  @change="onclick(radioArray[index])">
                <el-radio v-for="(subitem, i) in item.children" :key="i" :label="subitem" @change="handleRadioChanges(i,subitem)">{{subitem.name}}</el-radio>
              </el-radio-group>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <el-card class="munu">
        <el-collapse v-model="munuActiveNames">
          <el-collapse-item
            :label="item.name"
            :prop="item.name"
            class="check-group"
            v-for="(item, index) in munuList"
            :key="index"
            :title="item.name"
            :name="index"
          >
            <div> 
              <el-checkbox
                v-model="subitem.checkFlag"
                v-for="(subitem, i) in item.children"
                :key="i"
              >{{subitem.name}}</el-checkbox>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-button class="btn-first martop" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-card>
    </el-form>
  </div>
</template>

<script>
/**
 *@ClassName:editJobManagement
 *@Description:职务管理-新建/编辑页面
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-09
 */
export default {
  data() {
    return {
      rules: {
        Name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_jobManagementName'), trigger: 'blur' }],
        Flag: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_jobManagementFlag'), trigger: 'change' }],
      },
      disabledArr: {
        ruleFormDisabled: true,
        munuDisabled: true,
        authorityDisabled: true,
        radioDisabled: true,
      }, // 保存的集合
      disabledArrSave: {
        ruleFormDisabled: true,
        munuDisabled: true,
        authorityDisabled: true,
        radioDisabled: true,
      }, // 保存的集合Save
      disabledSaveData: '', // 保存数组存储json字符串
      isDisabled: true, // 保存的可点击
      isFlag: false, // 编辑:true 新增：false
      saveData: '', // 存储json字符串
      munuSaveData: '', // 管理菜单存储json字符串
      authoritySaveData: '', // 管理职责存储json字符串
      radioSaveData: '', // 管理单选集合
      munuList: [], // 所有菜单
      authorityList: [], // 所有职责
      munuActiveNames: [], // 菜单的折叠
      authorityActiveNames: [], // 职责的折叠
      collapse: [], // 权限说明的折叠
      radioArray: [], // 这个是必须的，选中的每一个职责的数据都会存在这个数组里去，没有这个会有问题      
      shoarr: [], // 存到这个数组里进行去重操作--暂无该需求
      ruleForm: {
        Name: '',
        Flag: 1,
      },
      flagList: this.$i18n.t('lang.EditJobManagement_flagList'), // 是否启用
    }
  },
  // #8449 add
  destroyed() {
    window.localStorage.setItem('jobManagementForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('jobManagementSaveData', JSON.stringify(this.saveData))
    window.localStorage.setItem('jobManagement_munuList', JSON.stringify(this.munuList))
    window.localStorage.setItem('jobManagement_munuSaveData', JSON.stringify(this.munuSaveData))
    window.localStorage.setItem('jobManagement_radioArray', JSON.stringify(this.radioArray))
    window.localStorage.setItem('jobManagement_radioSaveData', JSON.stringify(this.radioSaveData))
    window.localStorage.setItem('jobManagement_authoritySaveData', JSON.stringify(this.authoritySaveData))
    window.localStorage.setItem('jobManagement_authorityList', JSON.stringify(this.authorityList))
  },
  created() {
    // 这是用来保存disabled们初始数据
    this.disabledSaveData = JSON.stringify(this.disabledArrSave)
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
    this.id = this.$route.query.id
    // #8449 add
    if (window.localStorage.getItem('jobManagementForm')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('jobManagementForm'))
    if (window.localStorage.getItem('jobManagementSaveData')) {
      this.saveData = JSON.parse(window.localStorage.getItem('jobManagementSaveData'))
    }
    if (window.localStorage.getItem('jobManagement_munuList')) {
      this.munuList = JSON.parse(window.localStorage.getItem('jobManagement_munuList'))
    } 
    if (window.localStorage.getItem('jobManagement_munuSaveData')) {
      this.munuSaveData = JSON.parse(window.localStorage.getItem('jobManagement_munuSaveData'))
    }
    if (window.localStorage.getItem('jobManagement_authoritySaveData')) {
      this.authoritySaveData = JSON.parse(window.localStorage.getItem('jobManagement_authoritySaveData'))
    } 
    if (window.localStorage.getItem('jobManagement_authorityList')) {
      this.authorityList = JSON.parse(window.localStorage.getItem('jobManagement_authorityList'))
      if (window.localStorage.getItem('jobManagement_radioSaveData')) {
        this.radioSaveData = JSON.parse(window.localStorage.getItem('jobManagement_radioSaveData'))     
      } 
      if (window.localStorage.getItem('jobManagement_radioArray')) { 
        this.radioArray_tmp = JSON.parse(window.localStorage.getItem('jobManagement_radioArray'))  
        this.radioArray = []   
        for (var h = 0; h < this.authorityList.length; h++) {
          for (var k = 0; k < this.authorityList[h].children.length; k++) {
            if (this.authorityList[h].authorityType === 0) {
              if (this.authorityList[h].children[k].id === this.radioArray_tmp[0].id) {
                this.$set(this.authorityList[h].children[k], 'checkFlag', 1) // 这里，给对象添加属性，用$set方法  
                this.radioArray.push(this.authorityList[h].children[k])
              } else {
                this.$set(this.authorityList[h].children[k], 'checkFlag', 0) // 这里，给对象添加属性，用$set方法  
              }
            }
         }
       } 
      }   
    }
  } else {
    if (this.isFlag && this.isFlag !== 'false') {
      this.getEditData()
    } else {
      this.getAddData()
    }
  }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.disabledArr.ruleFormDisabled = true
        } else {
          // 变了
          this.disabledArr.ruleFormDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    munuList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.munuSaveData) {
          // 没变
          this.disabledArr.munuDisabled = true
        } else {
          // 变了
          this.disabledArr.munuDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    authorityList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.authoritySaveData) {
          // 没变
          this.disabledArr.authorityDisabled = true
        } else {
          // 变了
          this.disabledArr.authorityDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    radioArray: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.radioSaveData) {
          // 没变
          this.disabledArr.radioDisabled = true
        } else {
          // 变了
          this.disabledArr.radioDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    disabledArr: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.disabledSaveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 职责(单选)点击响应函数
    onclick(item) {
      console.log(item.name)// 职责(单选)下标
    },
    // 职责项单选变化监控--暂无该需求
    handleRadioChanges(index, item) { // index:选中的职责选项下标，item:选中的职责选项
      let data = { id: '', name: '', value: '' }
      data.id = item.id
      data.name = item.name
      data.value = parseInt(item.value)
      this.shoarr.push(data)// 将该项的item存到实现准备好的数组shoarr
      let myarr = this.shoarr
      for (var i = 0; i < myarr.length; i++) {
        for (var j = i + 1; j < myarr.length; j++) {
          if (myarr[i].id == myarr[j].id) {
            myarr.splice(i, 1)
            j--
          }
        }
      }// 数组去重，以该项最后一个选中为准
      this.shoarr = myarr 
    },
    // 职务管理编辑页面根据id获取数据
    getEditData() {
      let loading1 = this.$loading()
      this.$get(`/geMunuInfoById?id=${this.id}`).then(
        res => {
          loading1.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.munuList = res.result
            // 更新菜单显示数据到页面
            for (var i = 0; i < this.munuList.length; i++) {
              for (var j = 0; j < this.munuList[i].children.length; j++) {
                if (this.munuList[i].children[j].checkFlag === 1) {
                  this.$set(this.munuList[i].children[j], 'checkFlag', true) // 这里，给对象添加属性，用$set方法
                } else {
                  this.$set(this.munuList[i].children[j], 'checkFlag', false) // 这里，给对象添加属性，用$set方法
                }
              }
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.munuSaveData = JSON.stringify(this.munuList)
          }
        },
        error => {
          loading1.close()
          this.$message.error(error)
        }
      )
      let loading2 = this.$loading()
      this.$get(`/geAuthorityInfoById?id=${this.id}`).then(
        res => {
          loading2.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.authorityList = res.result
            // 更新菜单显示数据到页面
            var isCount = 0
            for (var h = 0; h < this.authorityList.length; h++) {
              for (var k = 0; k < this.authorityList[h].children.length; k++) {
                if (this.authorityList[h].authorityType === 1) {
                  if (this.authorityList[h].children[k].checkFlag === 1) {
                    this.$set(this.authorityList[h].children[k], 'checkFlag', true) // 这里，给对象添加属性，用$set方法
                  } else {
                    this.$set(this.authorityList[h].children[k], 'checkFlag', false)// 这里，给对象添加属性，用$set方法
                  }
                } else {
                  if (this.authorityList[h].children[k].checkFlag === 1) {
                    this.radioArray.push(this.authorityList[h].children[k])
                    isCount++
                  }
                }
              }
            }
            if (isCount === 0) {
              this.radioArray = []
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.radioSaveData = JSON.stringify(this.radioArray)
            this.authoritySaveData = JSON.stringify(this.authorityList)
          }
        },
        error => {
          loading2.close()
          this.$message.error(error)
        }
      )
      let loading3 = this.$loading()
      this.$get(`/geJobInfoById?id=${this.id}`).then(
        res => {
          loading3.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.ruleForm = res.result
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading3.close()
          this.$message.error(error)
        }
      )
    },
    // 职务管理新建页面获取数据
    getAddData() {
      this.ruleForm = {
        Name: '',
        Flag: 1,
      }
      this.saveData = JSON.stringify(this.ruleForm)
      let loading1 = this.$loading()
      this.$get(`/geMunuInfoById`).then(
        res => {
          loading1.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.munuList = res.result
            // 更新菜单显示数据到页面
            for (var i = 0; i < this.munuList.length; i++) {
              for (var j = 0; j < this.munuList[i].children.length; j++) {
                this.$set(this.munuList[i].children[j], 'checkFlag', false)// 这里，给对象添加属性，用$set方法
              }
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.munuSaveData = JSON.stringify(this.munuList)
          }
        },
        error => {
          loading1.close()
          this.$message.error(error)
        }
      )
      let loading2 = this.$loading()
      this.$get(`/geAuthorityInfoById`).then(
        res => {
          loading2.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.authorityList = res.result
            // 更新菜单显示数据到页面
            for (var h = 0; h < this.authorityList.length; h++) {
              for (var k = 0; k < this.authorityList[h].children.length; k++) {
                  if (this.authorityList[h].authorityType === 1) {
                    this.$set(this.authorityList[h].children[k], 'checkFlag', false)// 这里，给对象添加属性，用$set方法
                  } else {
                    this.$set(this.authorityList[h].children[k], 'checkFlag', 0)// 这里，给对象添加属性，用$set方法
                  }
                }
            }
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.radioSaveData = JSON.stringify(this.radioArray)
            this.authoritySaveData = JSON.stringify(this.authorityList)
          }
        },
        error => {
          loading2.close()
          this.$message.error(error)
        }
      )
    },
    // 返回
    back() {
      this.$router.push({ name: 'jobManagementList' })
    },
    // 保存
    save(formName) {
      let params = { }
      if (this.isFlag) {
        params.id = this.ruleForm.Id
      }
      params.name = this.ruleForm.Name
      params.flag = this.ruleForm.Flag

      let authorityId = []
      // for (var i = 0; i < this.authorityList.length; i++) {
      //   authorityId[i] = [] 
      //   for (var j = 0; j < this.authorityList[i].children.length; j++) {
      //     authorityId[i][j] = -1
      //   }
      // }
      for (var h = 0; h < this.authorityList.length; h++) {
        authorityId[h] = []
        for (var k = 0; k < this.authorityList[h].children.length; k++) {
          if (this.authorityList[h].authorityType === 1) {
            if (this.authorityList[h].children[k].checkFlag === true) {
              authorityId[h][k] = this.authorityList[h].children[k].id
            } 
          } else {
            var id = this.authorityList[h].children[k].id
            this.radioArray.forEach(function(item) {
              if (item.id === id) {
                authorityId[h][k] = id
              }
            })
          }
        }
      }
      params.jobAuthorityMap = authorityId

      let munuId = []
      // for (var x = 0; x < this.munuList.length; x++) {
      //   munuId[x] = [] 
      //   for (var y = 0; y < this.munuList[x].children.length; y++) {
      //     munuId[x][y] = -1
      //   }
      // }
      for (var z = 0; z < this.munuList.length; z++) {
        munuId[z] = []
        for (var w = 0; w < this.munuList[z].children.length; w++) {
          if (this.munuList[z].children[w].checkFlag === true) {
            munuId[z][w] = this.munuList[z].children[w].id
          }
        }
      }
      params.jobMunuMap = munuId

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$patch('/AOEJob', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.$router.push({ name: 'jobManagementList' })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 清空
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.Name = ''
      this.ruleForm.Flag = 1
      for (var i = 0; i < this.munuList.length; i++) {
        for (var j = 0; j < this.munuList[i].children.length; j++) {
          this.$set(this.munuList[i].children[j], 'checkFlag', false)
        }
      }
      for (var h = 0; h < this.authorityList.length; h++) {
        for (var k = 0; k < this.authorityList[h].children.length; k++) {
          if (this.authorityList[h].authorityType === 1) {
            this.$set(this.authorityList[h].children[k], 'checkFlag', false)
          }
        }
      }
      this.radioArray = []
    },
  } 
}
</script>

<style lang="scss">
.editJobManagement {
 .el-checkbox,.el-checkbox-button__inner,.el-radio{
   width:160px;
  }
  .collapse {
    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }
    .el-collapse {
      border-top: 0px;
    }
    .el-collapse-item__content {
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      will-change: height;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #ebeef5;
    }
  }
  .quote {
    color: steelblue;
  }
  .classical {
    color: #419641;
  }
  .input-width{
    width: 30%;
  }
  .subtitle{
    font-size: 16px;
    font-weight:bold;
    margin-top: 10px;
    margin-left: 20px;
    margin-bottom: 10px;
  }
  .martop {
    margin-top: 20px;
    margin-left: 20px;
  }
  .el-card {
    min-height: 0px;
    margin-top: 10px;
  }
  .el-collapse {
    border-top: 0px;
  }
  .munu {
    .el-form-item__content {  
      width: 60vw !important;
    }
    .el-collapse-item__content {
      padding-left: 150px;
    }
    .el-collapse-item__header {
      padding-left: 69px;
    }
  }
  .authority {
    .el-form-item__content {  
      width: 60vw !important;
    }
    .el-collapse-item__content {
      padding-left: 150px;
    }
    .el-collapse-item__header {
      padding-left: 69px;
    }
  } 
}
</style>